import { StepAction } from "./step-action";
import { ChemicalLot } from "./chemical-lot";

export class Step{
    step: string;
    startPUID: string;
    startTimeStamp: Date;
    endTimeStamp:Date;
    endPUID:string;
    action: StepAction[];
    actionMap?: Map<string, StepAction>;
    chemicals: ChemicalLot[];
    liquidHandler: string;
    endLiquidHandler?: string = "";
    status?: string;
}